package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class PomodoroCheckQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectByItem(item_id: String, mapper: (
    id: String,
    item_id: String,
    label: String,
    note: String?,
    checked: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByItemQuery(item_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectByItem(item_id: String): Query<Pomodoro_check> = selectByItem(item_id) { id,
      item_id_, label, note, checked, order_index, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Pomodoro_check(
      id,
      item_id_,
      label,
      note,
      checked,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    item_id: String,
    label: String,
    note: String?,
    checked: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(1_814_788_725, arrayOf("pomodoro_check"), driver, "PomodoroCheck.sq",
      "selectDirty",
      "SELECT pomodoro_check.id, pomodoro_check.item_id, pomodoro_check.label, pomodoro_check.note, pomodoro_check.checked, pomodoro_check.order_index, pomodoro_check.created_at, pomodoro_check.updated_at, pomodoro_check.is_deleted, pomodoro_check.deleted_at, pomodoro_check.synced_at FROM pomodoro_check WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectDirty(): Query<Pomodoro_check> = selectDirty { id, item_id, label, note, checked,
      order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Pomodoro_check(
      id,
      item_id,
      label,
      note,
      checked,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    item_id: String,
    label: String,
    note: String?,
    checked: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Pomodoro_check> = selectByIdAnyState(id) { id_,
      item_id, label, note, checked, order_index, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Pomodoro_check(
      id_,
      item_id,
      label,
      note,
      checked,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectAll(mapper: (
    id: String,
    item_id: String,
    label: String,
    note: String?,
    checked: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(1_391_828_228, arrayOf("pomodoro_check"), driver, "PomodoroCheck.sq",
      "selectAll",
      "SELECT pomodoro_check.id, pomodoro_check.item_id, pomodoro_check.label, pomodoro_check.note, pomodoro_check.checked, pomodoro_check.order_index, pomodoro_check.created_at, pomodoro_check.updated_at, pomodoro_check.is_deleted, pomodoro_check.deleted_at, pomodoro_check.synced_at FROM pomodoro_check WHERE is_deleted = 0 ORDER BY order_index") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectAll(): Query<Pomodoro_check> = selectAll { id, item_id, label, note, checked,
      order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Pomodoro_check(
      id,
      item_id,
      label,
      note,
      checked,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    item_id: String,
    label: String,
    note: String?,
    checked: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(1_070_553_370, """
        |INSERT INTO pomodoro_check(id, item_id, label, note, checked, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 8) {
          bindString(0, id)
          bindString(1, item_id)
          bindString(2, label)
          bindString(3, note)
          bindLong(4, checked)
          bindLong(5, order_index)
          bindLong(6, created_at)
          bindLong(7, updated_at)
        }
    notifyQueries(1_070_553_370) { emit ->
      emit("pomodoro_check")
    }
  }

  public fun updateChecked(
    checked: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_402_148_125,
        """UPDATE pomodoro_check SET checked = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, checked)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(1_402_148_125) { emit ->
      emit("pomodoro_check")
    }
  }

  public fun updateLabel(
    label: String,
    note: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_033_021_930,
        """UPDATE pomodoro_check SET label = ?, note = ?, updated_at = ? WHERE id = ?""", 4) {
          bindString(0, label)
          bindString(1, note)
          bindLong(2, updated_at)
          bindString(3, id)
        }
    notifyQueries(1_033_021_930) { emit ->
      emit("pomodoro_check")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_257_938_006,
        """UPDATE pomodoro_check SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(1_257_938_006) { emit ->
      emit("pomodoro_check")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(-1_834_135_672,
        """UPDATE pomodoro_check SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(-1_834_135_672) { emit ->
      emit("pomodoro_check")
    }
  }

  public fun update(
    item_id: String,
    label: String,
    note: String?,
    checked: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_415_499_562, """
        |UPDATE pomodoro_check
        |SET item_id = ?, label = ?, note = ?, checked = ?, order_index = ?, created_at = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 8) {
          bindString(0, item_id)
          bindString(1, label)
          bindString(2, note)
          bindLong(3, checked)
          bindLong(4, order_index)
          bindLong(5, created_at)
          bindLong(6, updated_at)
          bindString(7, id)
        }
    notifyQueries(1_415_499_562) { emit ->
      emit("pomodoro_check")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(-2_032_203_699,
        """UPDATE pomodoro_check SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-2_032_203_699) { emit ->
      emit("pomodoro_check")
    }
  }

  private inner class SelectByItemQuery<out T : Any>(
    public val item_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("pomodoro_check", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("pomodoro_check", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(380_171_719, """
    |SELECT pomodoro_check.id, pomodoro_check.item_id, pomodoro_check.label, pomodoro_check.note, pomodoro_check.checked, pomodoro_check.order_index, pomodoro_check.created_at, pomodoro_check.updated_at, pomodoro_check.is_deleted, pomodoro_check.deleted_at, pomodoro_check.synced_at FROM pomodoro_check
    |WHERE item_id = ? AND is_deleted = 0
    |ORDER BY order_index, created_at
    """.trimMargin(), mapper, 1) {
      bindString(0, item_id)
    }

    override fun toString(): String = "PomodoroCheck.sq:selectByItem"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("pomodoro_check", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("pomodoro_check", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(378_304_500,
        """SELECT pomodoro_check.id, pomodoro_check.item_id, pomodoro_check.label, pomodoro_check.note, pomodoro_check.checked, pomodoro_check.order_index, pomodoro_check.created_at, pomodoro_check.updated_at, pomodoro_check.is_deleted, pomodoro_check.deleted_at, pomodoro_check.synced_at FROM pomodoro_check WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "PomodoroCheck.sq:selectByIdAnyState"
  }
}
